import React from "react";

 
function WorkSmarter({items,title,subtitle}) {
  return (
    <div className="bg-busines-type h-auto lg:py-[4.94rem] py-[2rem] lg:px-[5.69rem] px-3">
      <div className="flex flex-col items-center justify-center text-center">
        <span className="text-[#111827] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] font-[500] leading-tight lg:leading-[3.375rem] max-w-full lg:max-w-[42rem] w-full">
      {title}
        </span>
        <span className="mt-[1rem] text-[#4B5563] text-[1rem] md:text-[1.125rem] font-[400] leading-[1.625rem] max-w-full">
       {subtitle}
        </span>
      </div>

      <div className="mt-[4rem] grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[1.5rem] md:gap-[1.98rem]">
        {items &&
          items?.map((item) => (
            <div className="lg:max-h-[17.1875rem] h-auto w-full">
              <img className="w-[3rem] h-[3rem] max-w-full object-contain" src={item?.svg} alt={item?.svg} />
              <div className="mt-[1.25rem] text-[#111827] text-[1.125rem] md:text-[1.25rem] font-[500] leading-[1.75rem]">
                {item?.title}
              </div>
              <div className="mt-[.75rem] text-[#4B5563] text-[1rem] md:text-[1.125rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[22.6875rem] w-full">
                {item?.desc}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default WorkSmarter;
